module.exports = __webpack_public_path__ + "static/media/person-raj-sasidharan.031a4d66.png";